import { fromJS } from 'immutable'

export const companyData = fromJS([{
"registry_company_name": "Level 3 Communications",
  "registry_city": "San Francisco",
  "registry_state": "CA",
  "registry_zip_code": "94108",
  "registry_area_code": 415,
  "registry_dma_code": 807,
  "registry_country": "United States",
  "registry_country_code": "US",
  "registry_country_code3": "USA",
  "registry_latitude": 37.791500091552734,
  "registry_longitude": -122.40889739990234,
  "company_name": "Demandbase Inc",
  "demandbase_sid": 3415304,
  "marketing_alias": "Demandbase",
  "industry": "Software & Technology",
  "sub_industry": "Software Applications",
  "employee_count": 200,
  "isp": false,
  "primary_sic": "7372",
  "primary_naics": null,
  "street_address": "680 Folsom St Suite 400",
  "city": "San Francisco",
  "state": "CA",
  "zip": "94107",
  "country": "US",
  "country_name": "United States",
  "phone": "415-683-2660",
  "stock_ticker": null,
  "web_site": "demandbase.com",
  "annual_sales": 40000000,
  "revenue_range": "$25M - $50M",
  "employee_range": "Mid-Market",
  "b2b": true,
  "b2c": false,
  "traffic": "Medium",
  "latitude": 37.7894,
  "longitude": -122.394,
  "fortune_1000": false,
  "forbes_2000": false,
  "information_level": "Detailed",
  "audience": "SMB",
  "audience_segment": "Software & Technology",
  "watch_list": {
    "Group_Id": "362",
    "Is_Primary": "1",
    "account_id": "001AL",
    "ao": "Brian",
    "mdr": "Leah",
    "asr": "Brian",
    "csm": "Anthony",
    "account_type": "Customer",
    "partner_owner": null,
    "demandbase_qualification_score": null,
    "ae_top_30": null
  },
  "access_type": "remote",
  "ip": "69.181.105.169",
  "region_name": "California"
}])



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/demandbase/demodata.js